<template>
    <div>
        <div class="mb-3"><button @click.prevent="showUserCreate" type="button" class="btn btn-link text-success p-0" style="line-height: 1" form=""><i class="fas fa-plus"></i> Добавить пользователя</button></div>
        <table class="table" v-if="users.length">
            <template v-for="u in users">
                <AgencyUserListItem :user="u" @openEditForm="openEditForm" />
            </template>
        </table>
        <el-dialog v-if="userFormVisible" :title="userFormState === 'form' ? 'Создание пользователя' : 'Пользователь создан!'" :visible.sync="userFormVisible" width="450px" :append-to-body="true">
            <AgencyUserForm v-if="userFormState === 'form'" :mode="userFormMode" :agency_id="+agency_id" @created="onCreated" @updated="onUpdated" :user="userForm" />
            <template v-if="userFormState === 'user_data'">
                <UserRegisterParams :data="userForm" />
            </template>
        </el-dialog>
    </div>
</template>

<script>
import UserRegisterParams from "../users/UserRegisterParams.vue";
import AgencyUserForm from "./AgencyUserForm.vue";
import AgencyUserListItem from "./AgencyUserListItem.vue";
import fa from "element-ui/src/locale/lang/fa";

export default {
    name: "AgencyUserList",
    components: {AgencyUserListItem, AgencyUserForm, UserRegisterParams},
    props: ['agency_id'],
    data: () => ({
        isLoading: false,
        users: [],
        userFormVisible: false,
        userFormMode: null,
        userFormState: "form",
        userForm: null,
    }),
    mounted() {
        this.fetchUsers();
    },
    methods: {
        fetchUsers() {
            let self = this;
            axios.get('/api/agencies/' + this.agency_id + '/users')
                .then(r => {
                    this.users = r.data
                    self.isLoading = false;
                })
        },
        onCreated(user) {
            this.userFormState = 'user_data';
            this.userForm = user;
            this.fetchUsers();
        },
        onUpdated(user) {
            this.userFormVisible = false;
            this.userForm = null;
            this.fetchUsers();
        },
        showUserCreate() {
            this.userFormVisible = true;
            this.userFormMode = "create";
            this.userFormState = "form";
            this.userForm = null;
        },
        openEditForm(data) {
            this.userForm = data;
            this.userFormState = "form";
            this.userFormMode = "edit";
            this.userFormVisible = true;
        }
    }
}
</script>

<style scoped>

</style>
